export const FeatureList = ({ list }) => {
    return (
        <div className="feature-list">
            <div className="feature-scroll">
                {list.map((feature, k) => (
                    <div className="home-feature" key={k}>
                        <img
                            src={`/svgs/${feature.icon}`}
                            className="home-vector"
                            alt=""
                        />
                        <div className="feature-cap">{feature.caption}</div>
                        <div className="feature-descr">{feature.text}</div>
                    </div>

                ))}
            </div>
        </div>
    )
}